import { render } from "./T&C.vue.ts?vue&type=template&id=fa1a1357&scoped=true&ts=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./T&C.vue?vue&type=template&id=fa1a1357&scoped=true&ts=true"
import script from "./T&C.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./T&C.vue?vue&type=script&setup=true&lang=ts"
export * from "./T&C.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./T&C.vue?vue&type=script&setup=true&lang=ts"

import "./T&C.vue.scss?vue&type=style&index=0&id=fa1a1357&lang=scss&scoped=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./T&C.vue?vue&type=style&index=0&id=fa1a1357&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1a1357"],['__file',"src/shared-components/consumer/T&C.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa1a1357"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa1a1357', __exports__)) {
    api.reload('fa1a1357', __exports__)
  }
  
  module.hot.accept("./T&C.vue.ts?vue&type=template&id=fa1a1357&scoped=true&ts=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./T&C.vue?vue&type=template&id=fa1a1357&scoped=true&ts=true", () => {
    api.rerender('fa1a1357', render)
  })

}


export default __exports__